<template>
  <div class="w-full px-4 sm:px-6 lg:px-8 py-6 max-w-7xl mx-auto">
    <!-- Breadcrumb y título -->
    <div class="mb-8">
      <nav class="flex items-center gap-1 text-sm text-gray-500 mb-2">
        <span>{{ breadcrumbParent }}</span>
        <svg class="w-4 h-4 mx-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
        <span class="text-gray-700 font-medium">{{ breadcrumbCurrent }}</span>
      </nav>
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <h1 class="text-3xl sm:text-4xl font-normal text-gray-900">{{ titulo }}</h1>
        <button @click="abrirSelectorArchivos" :disabled="cargando" class="inline-flex items-center justify-center gap-2 px-4 py-2 bg-white text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed">
          <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
          <span>{{ cargando ? 'Subiendo...' : 'Subir archivos' }}</span>
        </button>
      </div>
      <p class="mt-3 text-sm text-gray-500">
        <span class="font-medium">Límites:</span> Tamaño máximo 50MB · Tipos: PDF, imágenes, Word, Excel, CSV, TXT
      </p>
    </div>

    <!-- Mensaje de estado -->
    <div v-if="mensaje.texto" :class="[
      'mb-6 px-4 py-3 rounded-lg flex items-center gap-2',
      mensaje.tipo === 'error' ? 'bg-red-50 text-red-800' : 'bg-green-50 text-green-800'
    ]">
      <span>{{ mensaje.texto }}</span>
      <button @click="mensaje.texto = ''" class="ml-auto text-gray-400 hover:text-gray-600">✕</button>
    </div>

    <!-- Lista de archivos -->
    <div class="mb-8">
      <h2 class="text-lg font-medium text-gray-900 mb-4">
        Archivos subidos
        <span v-if="cargandoLista" class="text-sm text-gray-500 ml-2">(Cargando...)</span>
      </h2>

      <!-- Vista escritorio (tabla) -->
      <div class="hidden lg:block bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <table class="w-full">
          <thead>
            <tr class="border-b border-gray-100">
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500">Nombre</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500">Fecha</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500">Hora</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500">Autor</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-500">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100">
            <tr v-if="archivosLocal.length === 0 && !cargandoLista">
              <td colspan="5" class="px-4 py-12 text-center text-gray-500">
                <div class="flex flex-col items-center gap-2">
                  <svg class="w-8 h-8 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span>No hay archivos</span>
                </div>
              </td>
            </tr>
            <tr v-for="archivo in archivosLocal" :key="archivo.id" class="hover:bg-gray-50 transition-colors group">
              <td class="px-4 py-3">
                <button @click="verArchivo(archivo)" class="flex items-center gap-3 text-sm text-gray-900 hover:text-blue-600">
                  <svg class="w-5 h-5 text-gray-400 group-hover:text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span class="truncate max-w-xs">{{ archivo.nombre }}</span>
                </button>
              </td>
              <td class="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">{{ archivo.fecha }}</td>
              <td class="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">{{ archivo.hora }}</td>
              <td class="px-4 py-3 text-sm text-gray-600">{{ archivo.autor }}</td>
              <td class="px-4 py-3 text-right">
                <div class="flex items-center justify-end gap-1">
                  <button @click="descargar(archivo)" class="p-2 text-gray-500 rounded-full hover:bg-gray-100 transition-colors" title="Descargar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                  </button>
                  <button @click="abrirModalRenombrar(archivo)" class="p-2 text-gray-500 rounded-full hover:bg-gray-100 transition-colors" title="Renombrar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                  </button>
                  <button @click="abrirModalEliminar(archivo)" class="p-2 text-gray-500 rounded-full hover:bg-gray-100 transition-colors" title="Eliminar">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Vista móvil (tarjetas) -->
      <div class="lg:hidden space-y-3">
        <div v-if="archivosLocal.length === 0 && !cargandoLista" class="bg-white rounded-xl border border-gray-200 p-8 text-center">
          <svg class="w-10 h-10 text-gray-300 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p class="text-sm text-gray-500">No hay archivos</p>
        </div>
        <div v-for="archivo in archivosLocal" :key="archivo.id" class="bg-white rounded-xl border border-gray-200 p-4 shadow-sm hover:shadow-md transition-shadow">
          <div class="flex items-start gap-3 mb-3">
            <div class="flex-shrink-0 w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <div class="flex-1 min-w-0">
              <button @click="verArchivo(archivo)" class="text-sm font-medium text-gray-900 hover:text-blue-600 truncate block">
                {{ archivo.nombre }}
              </button>
              <p class="text-xs text-gray-500 mt-1">{{ archivo.autor }}</p>
            </div>
          </div>
          <div class="flex items-center gap-3 text-xs text-gray-500 mb-3">
            <div class="flex items-center gap-1">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span>{{ archivo.fecha }}</span>
            </div>
            <div class="flex items-center gap-1">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>{{ archivo.hora }}</span>
            </div>
          </div>
          <div class="flex gap-2">
            <button @click="abrirModalRenombrar(archivo)" class="flex-1 flex items-center justify-center gap-1 px-3 py-2 text-xs font-medium text-gray-700 bg-gray-50 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Renombrar
            </button>
            <button @click="descargar(archivo)" class="flex-1 flex items-center justify-center gap-1 px-3 py-2 text-xs font-medium text-gray-700 bg-gray-50 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Descargar
            </button>
            <button @click="abrirModalEliminar(archivo)" class="px-3 py-2 text-xs font-medium text-red-700 bg-red-50 border border-red-200 rounded-lg hover:bg-red-100 transition-colors" title="Eliminar">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal renombrar -->
    <div v-if="modalRenombrar.visible" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" @click.self="cerrarModalRenombrar">
      <div class="bg-white rounded-xl shadow-xl w-full max-w-md">
        <div class="px-6 py-4 border-b border-gray-100">
          <h3 class="text-lg font-medium text-gray-900">Renombrar archivo</h3>
        </div>
        <div class="px-6 py-4">
          <input ref="inputNuevoNombre" v-model="modalRenombrar.nuevoNombre" @keyup.enter="confirmarRenombrar" @keyup.esc="cerrarModalRenombrar" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Nuevo nombre" />
        </div>
        <div class="px-6 py-4 bg-gray-50 rounded-b-xl flex justify-end gap-3">
          <button @click="cerrarModalRenombrar" class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
            Cancelar
          </button>
          <button @click="confirmarRenombrar" :disabled="renombrando || !modalRenombrar.nuevoNombre.trim()" class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            {{ renombrando ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal visor -->
    <div v-if="modalVisor.visible" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80" @click.self="cerrarModalVisor">
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-6xl h-[90vh] flex flex-col">
        <div class="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
          <h3 class="text-lg font-medium text-gray-900 truncate">{{ modalVisor.nombreArchivo }}</h3>
          <button @click="cerrarModalVisor" class="text-gray-400 hover:text-gray-600">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="flex-1 overflow-auto bg-gray-50 p-6">
          <div v-if="!modalVisor.esVisualizable" class="flex items-center justify-center h-full">
            <div class="text-center max-w-md">
              <svg class="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
              <h4 class="text-lg font-medium text-gray-900 mb-2">Vista previa no disponible</h4>
              <p class="text-sm text-gray-600 mb-4">
                Los archivos {{ obtenerTipoArchivo(modalVisor.nombreArchivo) }} no se pueden previsualizar.
              </p>
              <button @click="descargarArchivoVisor" class="inline-flex items-center gap-2 px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Descargar
              </button>
            </div>
          </div>
          <template v-else-if="modalVisor.blobUrl">
            <img v-if="esImagen(modalVisor.nombreArchivo)" :src="modalVisor.blobUrl" class="w-full h-full object-contain rounded-lg" alt="Vista previa del archivo" />
            <iframe v-else :src="modalVisor.blobUrl" class="w-full h-full border-0 rounded-lg"></iframe>
          </template>
          <div v-else class="flex items-center justify-center h-full">
            <svg class="w-10 h-10 text-gray-300 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal eliminar -->
    <div v-if="modalEliminar.visible" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" @click.self="cerrarModalEliminar">
      <div class="bg-white rounded-xl shadow-xl w-full max-w-md">
        <div class="px-6 py-4 border-b border-gray-100">
          <h3 class="text-lg font-medium text-gray-900">Eliminar archivo</h3>
        </div>
        <div class="px-6 py-4">
          <p class="text-sm text-gray-600">
            ¿Eliminar <span class="font-medium text-gray-900">{{ modalEliminar.nombreArchivo }}</span>?
          </p>
          <p class="text-sm text-red-600 mt-2">Esta acción no se puede deshacer.</p>
        </div>
        <div class="px-6 py-4 bg-gray-50 rounded-b-xl flex justify-end gap-3">
          <button @click="cerrarModalEliminar" class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
            Cancelar
          </button>
          <button @click="confirmarEliminar" :disabled="eliminando" class="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            {{ eliminando ? 'Eliminando...' : 'Eliminar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Input file oculto -->
    <input ref="fileInput" type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.csv,.txt" @change="handleFileSelect" class="hidden" />
  </div>
</template>

<script>
import ArchivoDispositivoService from '@/services/dispositivos/archivoDispositivo.js'

export default {
  name: 'ModalGestorArchivo',

  props: {
    dispositivoId: {
      type: Number,
      required: true
    },
    breadcrumbParent: {
      type: String,
      default: 'Unidad efibox'
    },
    breadcrumbCurrent: {
      type: String,
      default: 'HVAC EQ11'
    },
    titulo: {
      type: String,
      default: 'Gestor de Archivos'
    }
  },

  data() {
    return {
      archivosLocal: [],
      cargando: false,
      cargandoLista: false,
      renombrando: false,
      eliminando: false,
      mensaje: {
        texto: '',
        tipo: ''
      },
      modalRenombrar: {
        visible: false,
        archivo: null,
        nuevoNombre: ''
      },
      modalEliminar: {
        visible: false,
        archivo: null,
        nombreArchivo: ''
      },
      modalVisor: {
        visible: false,
        blobUrl: null,
        nombreArchivo: '',
        esVisualizable: true,
        archivoActual: null
      }
    }
  },

  mounted() {
    this.cargarArchivos()
  },

  beforeUnmount() {
    this.limpiarBlobUrl()
  },

  methods: {
    async cargarArchivos() {
      try {
        this.cargandoLista = true
        this.archivosLocal = await ArchivoDispositivoService.listarArchivos(this.dispositivoId)
      } catch (error) {
        this.mostrarMensaje(error.message, 'error')
      } finally {
        this.cargandoLista = false
      }
    },

    abrirSelectorArchivos() {
      this.$refs.fileInput.click()
    },

    async handleFileSelect(event) {
      const files = Array.from(event.target.files)
      if (files.length === 0) return

      await this.subirArchivos(files)
      event.target.value = ''
    },

    async subirArchivos(files) {
      this.cargando = true
      let exitosos = 0
      let fallidos = 0

      for (const file of files) {
        try {
          await ArchivoDispositivoService.subirArchivo(this.dispositivoId, file)
          exitosos++
        } catch (error) {
          fallidos++
        }
      }

      this.cargando = false

      if (exitosos > 0) {
        this.mostrarMensaje(
          `${exitosos} archivo${exitosos > 1 ? 's' : ''} subido${exitosos > 1 ? 's' : ''} exitosamente`,
          'success'
        )
        await this.cargarArchivos()
      }

      if (fallidos > 0) {
        this.mostrarMensaje(
          `Error al subir ${fallidos} archivo${fallidos > 1 ? 's' : ''}`,
          'error'
        )
      }
    },

    async descargar(archivo) {
      try {
        await ArchivoDispositivoService.descargarArchivo(archivo.id, archivo.nombre)
        this.mostrarMensaje('Descarga iniciada', 'success')
      } catch (error) {
        this.mostrarMensaje(error.message, 'error')
      }
    },

    async descargarArchivoVisor() {
      if (this.modalVisor.archivoActual) {
        await this.descargar(this.modalVisor.archivoActual)
      }
    },

    async verArchivo(archivo) {
      try {
        this.modalVisor = {
          visible: true,
          blobUrl: null,
          nombreArchivo: archivo.nombre,
          esVisualizable: archivo.esVisualizable,
          archivoActual: archivo
        }

        // Solo cargar blob si es visualizable
        if (archivo.esVisualizable) {
          const blob = await ArchivoDispositivoService.obtenerArchivoBlob(archivo.id)
          this.limpiarBlobUrl()

          let url = URL.createObjectURL(blob)
          if (archivo.nombre.toLowerCase().endsWith('.pdf')) {
            url += '#view=FitH' // Fuerza al visor de PDF a ajustarse al ancho
          }
          this.modalVisor.blobUrl = url
        }
      } catch (error) {
        this.cerrarModalVisor()
        this.mostrarMensaje(error.message, 'error')
      }
    },

    cerrarModalVisor() {
      this.limpiarBlobUrl()
      this.modalVisor = {
        visible: false,
        blobUrl: null,
        nombreArchivo: '',
        esVisualizable: true,
        archivoActual: null
      }
    },

    limpiarBlobUrl() {
      if (this.modalVisor.blobUrl) {
        URL.revokeObjectURL(this.modalVisor.blobUrl)
      }
    },

    obtenerTipoArchivo(nombreArchivo) {
      const extension = nombreArchivo.toLowerCase().split('.').pop()
      const tipos = {
        'doc': 'Word (.doc)',
        'docx': 'Word (.docx)',
        'xls': 'Excel (.xls)',
        'xlsx': 'Excel (.xlsx)'
      }
      return tipos[extension] || extension.toUpperCase()
    },

    esImagen(nombreArchivo) {
      if (!nombreArchivo) return false
      const extension = nombreArchivo.toLowerCase().split('.').pop()
      return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(extension)
    },

    abrirModalRenombrar(archivo) {
      this.modalRenombrar = {
        visible: true,
        archivo: archivo,
        nuevoNombre: archivo.nombre
      }
      this.$nextTick(() => {
        this.$refs.inputNuevoNombre?.focus()
        this.$refs.inputNuevoNombre?.select()
      })
    },

    cerrarModalRenombrar() {
      this.modalRenombrar = {
        visible: false,
        archivo: null,
        nuevoNombre: ''
      }
    },

    async confirmarRenombrar() {
      const { archivo, nuevoNombre } = this.modalRenombrar

      if (!nuevoNombre.trim() || nuevoNombre === archivo.nombre) {
        this.cerrarModalRenombrar()
        return
      }

      try {
        this.renombrando = true
        await ArchivoDispositivoService.renombrarArchivo(archivo.id, nuevoNombre)

        const index = this.archivosLocal.findIndex(a => a.id === archivo.id)
        if (index !== -1) {
          this.archivosLocal[index].nombre = nuevoNombre.trim()
        }

        this.mostrarMensaje('Archivo renombrado exitosamente', 'success')
        this.cerrarModalRenombrar()
      } catch (error) {
        this.mostrarMensaje(error.message, 'error')
      } finally {
        this.renombrando = false
      }
    },

    abrirModalEliminar(archivo) {
      this.modalEliminar = {
        visible: true,
        archivo: archivo,
        nombreArchivo: archivo.nombre
      }
    },

    cerrarModalEliminar() {
      this.modalEliminar = {
        visible: false,
        archivo: null,
        nombreArchivo: ''
      }
    },

    async confirmarEliminar() {
      const { archivo } = this.modalEliminar

      try {
        this.eliminando = true
        await ArchivoDispositivoService.eliminarArchivo(archivo.id)

        this.archivosLocal = this.archivosLocal.filter(a => a.id !== archivo.id)

        this.mostrarMensaje('Archivo eliminado exitosamente', 'success')
        this.cerrarModalEliminar()
      } catch (error) {
        this.mostrarMensaje(error.message, 'error')
      } finally {
        this.eliminando = false
      }
    },

    mostrarMensaje(texto, tipo) {
      this.mensaje = { texto, tipo }
      setTimeout(() => {
        this.mensaje = { texto: '', tipo: '' }
      }, 5000)
    }
  }
}
</script>